export const GetSpotWalletInfo = "/SpotWallet/GetSpotWalletInfo";

export const GetPortfolioChart = (walletTypeId) =>
  `/Portfolio/GetPortfolioChart?WalletTypeId=${walletTypeId}`;

export const GetSpotWalletList = (limit) =>
  `/SpotWallet/GetSpotWalletList?IsShowMore=${limit}`;

// margin wallet
export const GetMarginWalletInfo = "/MarginWallet/GetMarginWalletInfo";

export const GetMarginWalletList = (limit) =>
  `/MarginWallet/GetMarginWalletList?IsShowMore=${limit}`;
